import { Button, Callout, Card, Flex, Heading, Text } from '@radix-ui/themes'
import { Link } from '@remix-run/react'
import { type TFunction } from 'i18next'
import * as React from 'react'
import { RxInfoCircled, RxPlus } from 'react-icons/rx'

import { HiOutlineMapPin } from "react-icons/hi2";
import { type GetAddresses } from '~/models/ecommerce-providers/sylius/shop/fetch/address/get-addresses'
import { PROFILE_ADDRESSES_SEARCH_PARAMS } from '~/routes/($lang).profile.addresses/addresses.component'
import { type PROFILE_ADDRESSES_INDEX_I18NEXT } from '~/routes/($lang).profile.addresses._index/index.component'

type NoItemsProps = {
	t: TFunction<
		PROFILE_ADDRESSES_INDEX_I18NEXT.routeProfileAddressesIndex,
		undefined
	>
	pagerViewCreated: string
	addresses: GetAddresses
	searchParams: URLSearchParams
}

const NoItems: React.FC<NoItemsProps> = ({
	t,
	pagerViewCreated,
	addresses,
	searchParams,
}) => {
	return (
		<Flex justify="center" align="center" width="100%" height="100%">
			<Card size="5">
				<Flex direction="column" align="center" gapY="6">
          <Text color="gray">
						<HiOutlineMapPin size="2.2em" />
					</Text>
					<Heading as="h3" color="gray">
						{t('noItems.common.title')}
					</Heading>
					{!!addresses.hydra!['hydra:totalItems'] &&
						(searchParams.has(PROFILE_ADDRESSES_SEARCH_PARAMS.page) ||
							searchParams.has(
								PROFILE_ADDRESSES_SEARCH_PARAMS.itemsPerPage,
							)) && (
							<Callout.Root color="blue">
								<Callout.Icon>
									<RxInfoCircled />
								</Callout.Icon>
								<Callout.Text>
									{t('noItems.common.wrongSearchParams')}
								</Callout.Text>
							</Callout.Root>
						)}
					<Link to={`create${pagerViewCreated}`} prefetch="viewport">
						<Button size="3" mt="3">
							<RxPlus size="1.2em" />
							{t('noItems.button.createAddress')}
						</Button>
					</Link>
				</Flex>
			</Card>
		</Flex>
	)
}

export { NoItems }
